<template>
  <div>
    <el-table
      :data="detailList"
      stripe
      border
      style="width: 100%"
      header-row-class-name="header_table_row"
    >
      <el-table-column label="资产编号" width="120" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.facilityNo }}</div>
        </template>
      </el-table-column>
      <el-table-column label="资产名称" width="140" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.facilityName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="盘点信息" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.content }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createBy"
        width="100"
        label="盘点人"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="isException"
        width="100"
        label="工单状态"
        align="center"
      >
        <template slot-scope="scope">
          <div :style="scope.row.isException ? 'color:red' : ''">
            {{ scope.row.isException ? "异常" : "正常" }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    detailList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  created() {
    console.log(this.detailList);
  },
  methods: {},
};
</script>

<style>
</style>